import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom'
import { Table } from "antd";
// import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
// import { adminMainUrl } from '../../../../Config';
const ViewMaster = ({ show, handleClose, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const closeButtonRef = useRef(null);
    const validationSchema = Yup.object({
        name: Yup.string().required('Name is required'),
        code: Yup.string().required('Code is required'),
        short_name: Yup.string().required('Short Name is required'),
        applicabl_for: Yup.string().required('Applicable for is required'),
        charge_category: Yup.string().required('Charge Category is required'),
        IATA_code: Yup.string().required('IATA Code is required'),
        // name: Yup.string().required('Code is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            name: '', // Initial value for the RequiredService type
            code: '',
            short_name: '',
            applicabl_for: '',
            charge_category: '',
            IATA_code: '',
            name: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            handleClose()
            formik.resetForm();
            setIsSubmitting(true);
            // try {
            //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
            //         },
            //         body: JSON.stringify(values),
            //     });

            //     const data = await response.json();

            //     if (response.ok) {
            //         // closeButtonRef.current.click();
            //         if (onSuccess) onSuccess();
            //         toast.success(data?.msg);
            //         handleClose()
            //         formik.resetForm();
            //     } else {
            //         toast.error(data?.msg);
            //         // Handle errors from the server
            //         console.error('Error creating RequiredService Type:', data.message);
            //     }
            // } catch (error) {
            //     console.error('Network error:', error);
            // }
            // finally {
            //     setIsSubmitting(false); // Stop the spinner
            // }
        },
    });
    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Name", dataIndex: "Name", key: "Name" },
        { title: "Code", dataIndex: "Code", key: "Code" },
        { title: "Action", dataIndex: "action", key: "action" },
      ];

    const dataSource = [{
        key: "1", // Add a unique key for each row
        SNo: "1", // Changed to camelCase
        Name: "John", 
        Code: "AE",
        action: (
          <div className="dropdown table-action">
            <Link to="#" className="action-icon" data-bs-toggle="dropdown">
              <i className="fa fa-ellipsis-v"></i>
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <div className="dropdown-item cursor-pointer" to="#" >
                <i className="fas fa-trash text-blue me-2"></i> Delete
              </div>
            </div>
          </div>
        )
      }]

    const ApplicableOption = []
    return (
        <Offcanvas className="" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Terminal Operator Information</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-6">

                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="name"
                                    name="name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                />
                                {formik.touched.name && formik.errors.name ? (
                                    <div className="error">{formik.errors.name}</div>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Code <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="code"
                                    name="code"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.code}
                                />
                                {formik.touched.code && formik.errors.code ? (
                                    <div className="error">{formik.errors.code}</div>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3 row">
                                <label htmlFor="name" className="form-label col-md-4">
                                    Port Type <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className="form-check col-md-4">
									<input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
									<label className="form-check-label" for="flexCheckDefault">
										Air
									</label>
								</div>
                                <div className="form-check col-md-4">
									<input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
									<label className="form-check-label" for="flexCheckDefault">
										Sea
									</label>
								</div>
                                {formik.touched.short_name && formik.errors.short_name ? (
                                    <div className="error">{formik.errors.short_name}</div>
                                ) : null}
                            </div>

                        </div>
                        <div className="col-12">
                            <div className="mb-3">
                                <div className="card">
                                    <div className="card-header">
                                        Add Port 
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                    <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Nature <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select
                                        className="custom-selector"
                                        options={ApplicableOption}
                                        value={ApplicableOption.find(option => option.value === formik.values.applicableFor) || null}
                                        onChange={(selectedOption) => formik.setFieldValue("applicableFor", selectedOption.value)}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.charge_category && formik.errors.charge_category ? (
                                        <div className="error">{formik.errors.charge_category}</div>
                                    ) : null}
                                    {formik.touched.IATACode && formik.errors.IATACode ? (
                                        <div className="error">{formik.errors.IATACode}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 d-flex align-items-end mb-2">
                        <button className="btn btn-primary text-xs" type="submit">
                            Add Port
                        </button>
                        </div>
                        </div>
                                    <div className="table-responsive custom-table">
                <Table className="table datanew dataTable no-footer" pagination={false}
                  dataSource={dataSource} columns={columns} />
              </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit" onClick={handleClose}>
                            Submit
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default ViewMaster